import React from "react"
import { graphql } from "gatsby"
import { Layout } from "@bw/layouts"
import { Seo, Container, CmsImage } from "@bw/bits"
import { Content, Footer, Header } from "../components/modules/mapModules.jsx"
import { PageHeader } from "@bw/modules"
import { Breadcrumbs } from "@bw/partials"
import styled from "styled-components"

const DateWrapper = styled.div`
  padding: 15px 0;
`
const NewsTemplate = ({ data, pageContext, location }) => {
  const { collectionNews, mount } = data
  const page = collectionNews

  const breadcrumbsLinks = [
    {
      title: "Accueil",
      to: "/",
    },
    {
      title: mount.title,
      to: mount.slug,
    },
  ]

  if (page.category) {
    breadcrumbsLinks.push({
      title: page.category.title,
      to: mount.slug + "/" + page.category.slug,
    })
  }

  breadcrumbsLinks.push({
    title: page.title,
    to: page.slug,
  })

  const mountImage = mount.header[0]?.image

  return (
    <Layout color={page.color?.value} {...{ pageContext }}>
      <Seo
        url={location.href}
        title={page.metaTitle || page.title}
        description={page.metaDescription}
        image={page.image?.url}
        meta={[
          {
            name: "robots",
            content: page.doNotIndex
              ? "noindex, nofollow"
              : "max-image-preview:large, index, follow",
          },
        ]}
      />
      <Header
        modules={[
          {
            __typename: "PageHeaderModule",
            title: page.title,
            subtitle: "Restez informés grâce à nos différentes publications.",
            image: mountImage,
          },
        ]}
        page={page}
      />
      {breadcrumbsLinks && <Breadcrumbs breadcrumbs={breadcrumbsLinks} />}
      <Container>
        {page.date && <DateWrapper>{page.date}</DateWrapper>}
      </Container>
      <Content modules={page.content} />
      <Footer modules={page.footer} />
    </Layout>
  )
}

export default NewsTemplate

export const newsQuery = graphql`
  query newsQuery($id: String!) {
    collectionNews(id: { eq: $id }) {
      title
      metaTitle
      metaDescription
      slug
      date(formatString: "D MMMM YYYY", locale: "fr")
      locale
      color {
        value
      }
      pictogram {
        value
      }
      image {
        url
      }
      doNotIndex
      content {
        __typename
        suptitle
        title
        subtitle
        buttonType {
          value
        }
        buttonUrl
        buttonIsExternal
        buttonText
        buttonPosition {
          value
        }
        buttonEntry {
          url
        }
        ancre

        ... on CallToActionModule {
          ...CallToActionModuleFragment
        }
        ... on ContentModule {
          ...ContentModuleFragment
        }
        ... on ContentWithImageModule {
          ...ContentWithImageModuleFragment
        }
        ... on GalleryModule {
          ...GalleryModuleFragment
        }
        ... on ContentOnColumnsModule {
          ...ContentOnColumnsModuleFragment
        }
        ... on MinusModule {
          ...MinusModuleFragment
        }
        ... on TeasersLatestModule {
          ...TeasersLatestModuleFragment
        }
        ... on LogoGridModule {
          ...LogoGridModuleFragment
        }
        ... on ImageModule {
          ...ImageModuleFragment
        }
        ... on DownloadsModule {
          ...DownloadsModuleFragment
        }
        ... on VideoModule {
          ...VideoModuleFragment
        }
      }
      footer {
        __typename
        suptitle
        title
        subtitle
        buttonType {
          value
        }
        buttonUrl
        buttonIsExternal
        buttonText
        buttonPosition {
          value
        }
        buttonEntry {
          url
        }
      }
    }

    mount: collectionPages(mount: { handle: { eq: "news" } }) {
      slug
      title
      header {
        ... on PageHeaderModule {
          image {
            url
          }
        }
      }
    }
  }
`
